<template>
  <div id="app">
    <!-- <img src="../../views/apps/our_company/Img/Prueba.png" /> -->
    <img src="./Img/MisionVF.jpg" width="1700" height="800" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    Company() {
      console.log("Company: ", this.currentCompany);
      return this.currentCompany;
    },
    ImageFrom() {
      let image;
      console.log("currentCompany:", this.currentCompany);
      switch (this.currentCompany) {
        case "TB": {
          image = "./Img/MisionTB.jpg";
          console.log("TB:", image);
          break;
        }

        case "VF": {
          image = "./Img/MisionVF.jpg";
          console.log("VF:", image);
          break;
        }
      }

      return image;
    }
  }
};
</script>

<style lang="css"></style>
